import React from "react";
import Card from "../../../newComponents/card";
import GeneralSection from "../../../newComponents/generalSection";

const personGroup = ({ blocks }) => (
  <GeneralSection>
    <div className="boxes swiper-container js-load-more js-slider-boxes-projects">
      <ul>
      {blocks.map((block, i) => (
      <Card image={block.profilePicture[0]} ar={1/1} title={block.fullName} subtitle={block.position}/>
    ))}
      </ul>
      <div className="swiper-pagination boxes__pagination" />
    </div>
  </GeneralSection>
);

export default personGroup;